import { BillingMethodEnum } from "@enums/billingMethodEnum.enum";

export class UserTableEntry {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  rfidCardsString: string;
  allowedChargingStationsString: string;
  pricingName?: string;
  price: number;
  billingMethod?: BillingMethodEnum;
  company?: string;
  contactPerson?: string;

  stripeSubscriptionId: string;
  stripeCustomerId: string;
  stripePaymentMethodId: string;
  stripeInvoiceId: string;

  isStripeSubscripitionActive?: boolean
  requiredActionMessage: string

  getPrimaryKey() {
    return this.id;
  }
}
